import { render } from "./KnowledgeNet.vue?vue&type=template&id=3421ad9c&scoped=true"
import script from "./KnowledgeNet.vue?vue&type=script&lang=js"
export * from "./KnowledgeNet.vue?vue&type=script&lang=js"

import "./KnowledgeNet.vue?vue&type=style&index=0&id=3421ad9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3421ad9c"]])

export default __exports__